import { Box, Typography, Button, Link as MuiLink } from "@mui/material";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { LoginStatuses } from "../../constants";
import styles from './styles.module.scss';

const LoginSuccess = (props) => {
    const { isLoggedIn } = props;
    const navigate = useNavigate()

    const onClick = () => {
        navigate('/pages');
    }

    if(isLoggedIn !== LoginStatuses.completed) return null;

    return (
        <Box className={styles.loginSuccessContainer}>
            <Typography className={styles.loginSuccessTitle}>
                Login successful!
            </Typography>
            <Typography className={styles.loginSuccessDescription}>
                Website Mapping has been started automatically.<br/>
                Your first test case generation has started automatically.<br/>
                Go to <MuiLink component={RouterLink} to="/pages" underline="hover" color="secondary">Pages</MuiLink> to choose more.
            </Typography>
            <Box sx={{ display: "flex" }}>
                <Button
                    className={styles.loginSuccessButton}
                    variant="contained"
                    color="secondary"
                    onClick={onClick}
                >
                    Go to Pages
                </Button>
            </Box>
        </Box>
    );
}

export default LoginSuccess;